import React, { Fragment } from 'react';
import { isValid } from '../../../utils';
import './about-us.scss';

const OurContent = ({
  isMobile,
  isPage,
  hedUrl,
}) => {
  const { SITE_HOST } = process.env;
  const wrapperClass = isValid(hedUrl) && hedUrl === 'about-us' ? 'content-category-wrapper about-us' : 'content-category-wrapper';

  const contentData = [
    {
      category: 'beauty',
      url: `${SITE_HOST}/beauty`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/1-beauty-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/1-beauty-image.webp',
    },
    {
      category: 'wellness',
      url: `${SITE_HOST}/wellness`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/2-wellness-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/2-wellness-image.webp',
    },
    {
      category: 'food',
      url: `${SITE_HOST}/food`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/3-food-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/3-food-image.webp',
    },
    {
      category: 'family',
      url: `${SITE_HOST}/family`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/4-family-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/4-family-image.webp',
    },
    {
      category: 'fashion',
      url: `${SITE_HOST}/fashion`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/5-fashion-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/5-fashion-image.webp',
    },
    {
      category: 'entertainment',
      url: `${SITE_HOST}/entertainment`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/6-entertainment-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/6-entertainment-image.webp',
    },
    {
      category: 'news',
      url: `${SITE_HOST}/news`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/7-news-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/7-news-image.webp',
    },
    {
      category: 'home',
      url: `${SITE_HOST}/home`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/8-home-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/8-home-image.webp',
    },
    {
      category: 'travel',
      url: `${SITE_HOST}/travel`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/9-travel-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/9-travel-image.webp',
    },
    {
      category: 'pets',
      url: `${SITE_HOST}/pets`,
      imgSrcDesktop: 'https://www.purewow.com/static-gmg/purewow/about-us/desktop/10-pets-image.webp',
      imgSrcMobile: 'https://www.purewow.com/static-gmg/purewow/about-us/mobile/10-pets-image.webp',
    },
  ];

  const renderedContent = contentData.map((cat, i) => {
    const { category, url, imgSrcDesktop, imgSrcMobile } = cat;
    const desktopImg = isValid(imgSrcDesktop) ? imgSrcDesktop : null;
    const mobileImg = isValid(imgSrcMobile) ? imgSrcMobile : null;
    let categoryImg = null;
    if (isValid(desktopImg) && !isMobile) {
      categoryImg = desktopImg;
    } else if (isValid(mobileImg) && isMobile) {
      categoryImg = mobileImg;
    }
    const categoryLabel = isValid(category) ? category : null;
    const categoryLink = isValid(url) ? url : null;
    return (
      <>
        <div className='category-item'>
          <img className='category-img' src={categoryImg}/>
          <div className='category-label'>{categoryLabel}</div>
          <a className='see-more' href={categoryLink}>see more</a>
        </div>
      </>
    );
  });

  return (
    <>
      <div className={wrapperClass}>
        {renderedContent}
      </div>
    </>
  );
};

export default OurContent;
